import React, { useState, useEffect } from 'react';
import useSWR from 'swr';
import { useSelector } from 'react-redux';
import { axios } from '@service/axiosService';

export const useSWRidget = (link = null) => {
  const projectId = useSelector((state) => state.common.currentId);
  const [widgetId, setWidgetId] = useState(null);
  const urlGet = `/api/v1/project/customizeChart/${widgetId}`;
  const urlPost = `/api/v1/project/customizeChart/${projectId}`;

  useEffect(() => {
    if (link && link !== 'empty-widget') {
      setWidgetId(link);
    } else if (widgetId) {
      setWidgetId(null);
    }
  }, [link]);

  const fetcher = () =>
    axios.get(urlGet).then((res) => ({
      ...res.widgetInfo,
      data: JSON.parse(res.widgetInfo.data),
    }));

  const { data, error, mutate, isLoading } = useSWR(
    widgetId ? `customizeWidget/${widgetId}` : null,
    fetcher,
    { dedupingInterval: 30000 },
  );

  const createWidget = async (chartType, moduleId, moduleType) => {
    const res = await axios.post(urlPost, {
      chartType,
      moduleId,
      moduleType,
      data: [],
    });
    if (res.message === 'save chart successfully') {
      setWidgetId(res.id);
      return res.id;
    }
    return res;
  };

  const saveWidget = (v) => {
    const newData = { ...data, data: [...v] };
    mutate(
      axios.post(urlPost, newData).then(() => newData),
      {
        optimisticData: newData,
        rollbackOnError: true,
        populateCache: true,
      },
    );
  };

  return {
    widgetId,
    widgetData: data,
    createWidget,
    saveWidget,
    error,
    isLoading,
  };
};
